import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Modal from '@components/ResponsiveModal';
import SimpleButton, { COLOR } from '@components/SimpleButton';
import Container from './components/Container';
import Footer from './components/Footer';
import Subtitle from './components/Subtitle';
import Description from './components/Description';
import Title from './components/Title';
import IconContainer from './components/IconContainer';
const onCloseDefault = () => {};

const showButton = (text, onClick) => Boolean(text && onClick);

function SimpleButtonModal({
  open,
  title,
  subtitle,
  description,
  firstText,
  secondText,
  onFirstOptionClick,
  onSecondOptionClick,
  firstButtonColor,
  secondButtonColor,
  onClose,
  small,
  icon,
}) {
  const showFirstButton = showButton(firstText, onFirstOptionClick);
  const showSecondButton = showButton(secondText, onSecondOptionClick);
  const classes = {
    modal: classnames('modal', { small }),
    overlay: 'modal__overlay',
  };

  return (
    <Modal
      open={open}
      center
      classNames={classes}
      showCloseIcon={false}
      onClose={onClose}
    >
      <Container>
        {Boolean(icon) && typeof icon === 'string' && (
          <IconContainer>
            <div className="image">
              <img src={icon} alt="Modal icon" />
            </div>
          </IconContainer>
        )}

        {Boolean(icon) && typeof icon === 'object' && icon}

        <Title>{title}</Title>

        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {description && <Description>{description}</Description>}

        <Footer>
          {showFirstButton && (
            <SimpleButton
              elementId="simpleButtonModal__firstOption"
              label={firstText}
              color={firstButtonColor}
              onClick={onFirstOptionClick}
            />
          )}

          {showSecondButton && (
            <SimpleButton
              elementId="simpleButtonModal__secondOption"
              label={secondText}
              color={secondButtonColor}
              onClick={onSecondOptionClick}
            />
          )}
        </Footer>
      </Container>
    </Modal>
  );
}

SimpleButtonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  firstText: PropTypes.string,
  secondText: PropTypes.string,
  firstButtonColor: PropTypes.string,
  secondButtonColor: PropTypes.string,
  small: PropTypes.bool,
  onFirstOptionClick: PropTypes.func,
  onSecondOptionClick: PropTypes.func,
  onClose: PropTypes.func,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

SimpleButtonModal.defaultProps = {
  small: false,
  onClose: onCloseDefault,
  firstButtonColor: COLOR.SECONDARY,
  secondButtonColor: COLOR.PRIMARY,
};

export default SimpleButtonModal;
